import { Component, OnInit } from "@angular/core";
import { environment } from "../../../environments/environment";
import { AppService } from "../../services/app.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-forgotpassword",
  templateUrl: "./forgotpassword.component.html",
})
export class ForgotpasswordComponent implements OnInit {
  linkFormSubmitted = false;
  linkForm: FormGroup;
  selectedlang: any = [];
  disableSubmitButton = false;
  constructor(
    private appService: AppService,
    private linkBuilder: FormBuilder
  ) {
    this.linkForm = this.linkBuilder.group({
      email: [
        "",
        [Validators.required, Validators.pattern(environment.emailPattern)],
      ],
    });
    this.disableSubmitButton = false;
  }
  ngOnInit() {
    this.appService.getlang().subscribe((res) => {
      if (res && res["forgotPage"]) {
        this.selectedlang = res["forgotPage"];
      }
    });
    if (
      localStorage.getItem("email") &&
      localStorage.getItem("email") != null
    ) {
      this.linkForm.controls["email"].setValue(localStorage.getItem("email"));
    }
  }
  errorMsg = false;
  errorMsgData: any;
  successMsg = false;
  successMsgData: any;
  generatelink(data) {
    this.linkFormSubmitted = true;
    if (data.valid) {
      this.disableSubmitButton = true;
      this.linkFormSubmitted = false;
      const value = {
        email: data.value.email,
        origin: 2,
      };
      this.appService.generateLink(value).subscribe(
        (res) => {
          if (res && res["status"]["status"] === 200) {
            this.errorMsg = false;
            sessionStorage.setItem("forgotEmailId", value.email);
            this.successMsg = true;
            this.successMsgData = this.selectedlang.verify;
            this.disableSubmitButton = false;
            setTimeout(() => {
              this.successMsg = false;
            }, 5000);
            return;
          }
          if (res && res["status"]["status"] == 238) {
            this.errorMsg = true;
            this.successMsg = false;
            this.errorMsgData = this.selectedlang.unverified;
            this.disableSubmitButton = false;
            setTimeout(() => {
              this.errorMsg = false;
            }, 5000);
            return;
          }
          if (res && res["status"]["status"] === 229) {
            this.errorMsg = true;
            this.successMsg = false;
            this.errorMsgData = this.selectedlang.userNotFound;
            this.disableSubmitButton = false;
            setTimeout(() => {
              this.errorMsg = false;
            }, 5000);
            return;
          }
        },
        (err) => {
          this.errorMsg = true;
          this.successMsg = false;
          this.errorMsgData = this.selectedlang.wrong;
          setTimeout(() => {
            this.errorMsg = false;
          }, 5000);
        }
      );
    } else {
      if (
        (data.get("email").errors && data.get("email").errors.required) ||
        data.get("email").touched
      ) {
        this.errorMsg = true;
        this.successMsg = false;
        this.errorMsgData = this.selectedlang.missingfields;
        setTimeout(() => {
          this.errorMsg = false;
        }, 5000);
      }
      if (
        data.get("email").errors &&
        data.get("email").errors.pattern &&
        data.get("email").touched
      ) {
        this.errorMsg = true;
        this.successMsg = false;
        this.errorMsgData = this.selectedlang.validEmail;
        setTimeout(() => {
          this.errorMsg = false;
        }, 5000);
      }
    }
  }
}
